import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeIn = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.08em]">
    <motion.span
      className={`block will-change-transform ${className}`}
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Kicker = ({ children, className = "" }) => (
  <div className={`flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] text-crimson dark:text-stalk ${className}`}>
    <span className="inline-block h-2 w-2 bg-crimson dark:bg-stalk" />
    <span>{children}</span>
  </div>
);

export const SectionShell = ({ id, children, className = "" }) => (
  <section id={id} className={`relative px-6 py-24 sm:px-10 sm:py-32 lg:px-16 ${className}`}>
    <div className="mx-auto w-full max-w-7xl">{children}</div>
  </section>
);
